// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { Captcha } from '../../../components/captcha/captcha.model';
import { SpAlert } from '../../../components/sp-alert/sp-alert.model';

/** @ngInject */
export function Controller(
    $scope,
    $state,
    $timeout,
    SmsGatewaysService,
    SmsUserActivationCodeGeneration,
    SmsUserRegistration,
) {

    $scope.smsUserRegistrationFirstPageFlag = true;
    $scope.smsUserRegistrationSecondPageFlag = false;
    $scope.notMatched = false;

    $scope.smsUserRegistration = {
        "mobilePhoneNumber" : null,
        "activationCode" : null,
        "pin" : null,
        "captchaResponse" : null
    };

    const captcha = $scope.captcha = new Captcha({isVisible: () => true});

    $scope.generateActivationCode = function() {
        $scope.smsUserRegistration.captchaResponse = captcha.response;
        localStorage.setItem('preferred-sms-gateway', $scope.smsUserRegistration.smsGatewayIdentifier);
        SmsUserActivationCodeGeneration.save($scope.smsUserRegistration, function(response) {
            $scope.smsUserRegistrationFirstPageFlag = false;
            $scope.smsUserRegistrationSecondPageFlag = true;
            $scope.smsUserRegistration.activationCode = null;
            $scope.smsUserRegistration.pin = null;
            $scope.confirmPin = null;
            $scope.notMatched = false;
            const key = 'sms.registration.messages.activation_code';
            $scope.topLevelMessage = new SpAlert('success', key);
        }, function(response) {
            var status = response.status;
            if (status == 412) {
                const key = 'registration.company.messages.invalid_captcha';
                $scope.topLevelMessage = new SpAlert('danger', key);
            } else {
                $scope.topLevelMessage = new SpAlert('danger', response.data.message);
            }
            captcha.reset();
        });
    };

    $scope.registerSmsUser = function() {
        SmsUserRegistration.save($scope.smsUserRegistration, function(response) {
            $scope.smsUserRegistrationFirstPageFlag = true;
            $scope.smsUserRegistrationSecondPageFlag = false;
            $scope.smsUserRegistration = {
                "mobilePhoneNumber" : null,
                "activationCode" : null,
                "pin" : null,
                "captchaResponse" : null
            };
            $scope.selectedCountry = null;
            $scope.notMatched = false;
            const key = 'sms.registration.messages.registration_succeeded';
            $scope.topLevelMessage = new SpAlert('success', key);
            $timeout(function() {
                $state.go('public.sms-user-otp');
            }, 3000);

        }, function(response) {
            $scope.smsUserRegistrationFirstPageFlag = false;
            $scope.smsUserRegistrationSecondPageFlag = true;
            $scope.smsUserRegistration.activationCode = null;
            $scope.smsUserRegistration.pin = null;
            $scope.confirmPin = null;
            $scope.notMatched = false;
            if (response.data.serviceErrorCode.toString() == 'ERR_101403') {
                $scope.cancel();
                $scope.topLevelMessage = new SpAlert('danger', response.data.message);
            } else {
                $scope.topLevelMessage = new SpAlert('danger', response.data.message);
            }
        });

    };

    $scope.cancel = function() {
        $scope.smsUserRegistrationFirstPageFlag = true;
        $scope.smsUserRegistrationSecondPageFlag = false;
        $scope.smsUserRegistration = {
            "mobilePhoneNumber" : null,
            "activationCode" : null,
            "pin" : null,
            "captchaResponse" : null
        };
        $scope.selectedCountry = null;
        $scope.notMatched = false;
        captcha.reset();
    };

    $scope.$watch('smsUserRegistrationFirstForm.$error.err', (error) => {
        if (error || !$scope.smsUserRegistration.mobilePhoneNumber) {
            $scope.gateways = [];
            $scope.smsUserRegistration.smsGatewayIdentifier = undefined;
        } else {
            SmsGatewaysService
                .getSmsGatewayList($scope.smsUserRegistration.mobilePhoneNumber)
                .then((gateways) => {
                    $scope.gateways = gateways;
                    const preferredGateway = localStorage.getItem('preferred-sms-gateway');
                    if (gateways.includes(preferredGateway)) {
                        $scope.smsUserRegistration.smsGatewayIdentifier = preferredGateway;
                    } else {
                        $scope.smsUserRegistration.smsGatewayIdentifier = gateways[0];
                    }
                });
        }
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/sms-user-registration/sms-user-registration.controller.js